<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    赤尾<br>
站点介<br>
赤尾站位于滨河大道与福祥街相交口，车站沿滨河大道东北-西南方向布设。东侧是汇港名苑、京基御景华城、赤尾村等住宅区，西侧为景福大厦、福田村，周围多为居民区，车站D出入口往前50米左右有一座本地居民的伯公庙。赤尾站车站装修设计风格与7号线全线车站统一，采用黄色基调风格，以B出入口外赤尾村为由命名为赤尾地铁站。该站为地下站<br><br>
运营时刻表(工作日<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间<br>
西丽湖	06:39	23:19	7号线	3分35秒	5分55<br>
太安	06:10	23:37	7号线	3分35秒	5分55<br><br>
运营时刻表(休息日<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间<br>
西丽湖	06:38	23:19	7号线	4分钟	5分55<br>
太安	06:08	23:37	7号线	4分钟	5分55<br><br>
运营时刻表(节假日<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间<br>
西丽湖	06:39	00:19	7号线	4分钟	5分55<br>
太安	06:08	00:37	7号线	4分钟	5分55<br><br>

站点出口信<br><br>
A出入口<br>
滨河大道东侧（南）、汇港名苑、怡兴苑、深华工业大厦、福滨南村、深圳水务集团上步水务大楼、赤尾二<br><br>
B出入口<br>
赤尾一街、赤尾三街、赤尾<br><br>
C出入口<br>
滨河大道东侧（北）、赤尾社区工作站、京基御景华城、鹏丽大<br><br>
D出入口<br>
滨河大道西侧（北）、福田区南华实验学校、福祥小区、福祥<br><br>
E出入口<br>
滨河大道西侧（南）、福群楼、深圳市福南小学、景福大厦、中国人寿保险（海外）股份有限公<br><br>
公交换乘信<br><br>
A出入口<br>
公交站名： 岗边村<br>
23路,28路,52路,73路,229路,382路,J1路,337路,366路,369路,372路,M362路,M463<br><br>
A出入口<br>
公交站名： 岗边村<br>
23路,28路,52路,73路,229路,382路,J1路,337路,366路,369路,372路,M362路,M463<br><br>
C出入口<br>
公交站名： 赤尾天<br>
23路,28路,52路,73路,369路,M463<br><br>
D出入口<br>
公交站名： 赤尾天<br>
23路,28路,52路,73路,214路,337路,366路,369路,372路,M362路,463路,E2<br><br>
D出入口<br>
公交站名： 无委大<br>
23路,28路,52路,73路,214路,337路,366路,369路,372路,M362路,463路,E2<br><br>
E出入口<br>
公交站名： 岗边村<br>
382路,J1路,23路,28路,52路,73路,214路,229路,337路,366路,369路,372路,M362路,M463<br><br>
E出入口<br>
公交站名： 岗边村<br>
382路,J1路,23路,28路,52路,73路,214路,229路,337路,366路,369路,372路,M362路,M463路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>